<template lang="pug">
  .div
    .columns
      .column.is-6
        .field
          label.label Descripción
            .control.has-icons-left.has-icons-right
              input.input.is-dark(
                type='text', 
                placeholder='',
                v-model="descripcion",
                :disabled="isDisabled"
              )
      .column.is-2
        .field
          label.label Periodo
          .control
            flat-pickr(
              v-model='periodo'
              :config="config"
              class="input"
              :disabled="isDisabled"
            )
      .column.is-2
        .field
          label.label Ubicación:
          .control
            .select.is-dark
              select(v-model="ubicacion" :disabled="isDisabled")
                option(v-for="u in ubicaciones" :key="u.id" :value="u.id") {{ u.valor }}
    .columns
      .column.is-6
        .field
          label.label Concepto:
          .control
            .select.is-dark
              select(v-model="concepto" :disabled="isDisabled")
                option(v-for="d in conceptos" :key="d.valor" :value="d.valor") {{ d.nombre }}
      .column.is-4
        .field
          label.label Tipo
          input#checkServ.is-checkradio.is-dark(type='radio', value='0' v-model='tipo' :disabled="isDisabled")
          label.is-size-6(for='checkServ') Servicio
          input#checkMaterial.is-checkradio.is-dark(type='radio', value='1' v-model='tipo' :disabled="isDisabled")
          label.is-size-6(for='checkMaterial') Material
    .columns
      .column.is-12
        bulma-accordion
          bulma-accordion-item
            p.title.is-4.has-text-weight-normal(slot='title')
              | Proveedor 1&nbsp
              span.tag(:class="selProveedor1 ? 'is-danger': ''" v-show='Object.keys(itemSelProv1).length > 0')
                | {{ itemSelProv1.nombre}} | {{totalP1 | currency}}
            i.material-icons(slot='icon') more_vert`````
            .high(slot='content')
              .columns
                .column.is-4
                  .field
                    label.label Nombre Proveedor
                    TypeaheadProveedor(:options="proveedores" :optionSelect="itemSelProv1" v-model="itemSelProv1" :isDisabled="isDisabled") 
                .column.is-2
                  .field
                    label.label Total
                      .control.has-icons-left.has-icons-right
                        input.input.is-dark(
                          type='text', 
                          placeholder='Total',
                          v-model="totalP1",
                          min="0",
                          :disabled="isDisabled"
                        )
                .column.is-2
                  .field
                    label.label IVA
                      .control.has-icons-left.has-icons-right
                        input.input.is-dark(
                          type='text', 
                          placeholder='0.00',
                          v-model="ivaP1",
                          min="0",
                          :disabled="isDisabled"
                        )
                .column.is-3
                  .field
                    label.label Moneda
                    input#checkM_MN1.is-checkradio.is-dark(type='radio', value='0' v-model='monedaP1' checked='checked' :disabled="isDisabled")
                    label.is-size-6(for='checkM_MN1') MN
                    input#checkM_Ext1.is-checkradio.is-dark(type='radio', value='1' v-model='monedaP1' :disabled="isDisabled")
                    label.is-size-6(for='checkM_Ext1') USD
                .column.is-1
                  .field
                    input#cbP1.is-checkradio.is-danger(type='checkbox' v-model='selProveedor1' :disabled="isDisabled")
                    label.is-size-6(for='cbP1')
              .columns.is-vcentered
                .column.is-6(v-show="!verSpanFile1")
                  .field
                    .file.is-black.has-name
                      label.file-label
                        input.file-input(type='file' ref="inputCotizacion1" @change="previewfileCotizacion($event, 1)" accept="application/pdf" :disabled="isDisabled")
                        span.file-cta
                          span.file-icon
                            i.fas.fa-upload
                          span.file-label
                            | Cotización&mldr;
                        span.file-name
                          | {{ fileCotizacion1.name }}&nbsp
                          button.delete.is-small(@click="deleteFile(1)")
                .column.is-6(v-show="verSpanFile1 && Object.keys(cotizacionEdit).length > 0")
                  span.tag.is-black
                    | {{ Object.keys(cotizacionEdit).length > 0 ? getFile(cotizacionEdit.cotizaciones[0].rutaFileCot) : ''}}
                  a.button.is-danger.is-rounded.is-small(@click="deleteCot(1)")
                    i.fas.fa-times
                .column.is-1
                  .field
                    label.label Usuario
                .column.is-4
                    TypeaheadUsuario(:options="usuarios" :optionSelect="usuarioSel1" v-model="usuarioSel1" :isDisabled="isDisabled")
    .columns
      .column.is-12
        bulma-accordion
          bulma-accordion-item
            p.title.is-4.has-text-weight-normal(slot='title')
              | Proveedor 2&nbsp
              span.tag(:class="selProveedor2 ? 'is-danger': ''" v-show='Object.keys(itemSelProv2).length > 0')
                | {{ itemSelProv2.nombre}} | {{totalP2 | currency}}
            i.material-icons(slot='icon') more_vert
            .high(slot='content') 
              .columns
                .column.is-4
                  .field
                    label.label Nombre Proveedor
                    TypeaheadProveedor(:options="proveedores" :optionSelect="itemSelProv2" v-model="itemSelProv2" :isDisabled="isDisabled")
                .column.is-2
                  .field
                    label.label Total
                      .control.has-icons-left.has-icons-right
                        input.input.is-dark(
                          type='text', 
                          placeholder='Total',
                          v-model="totalP2"
                          :disabled="isDisabled"
                        )
                .column.is-2
                  .field
                    label.label IVA
                      .control.has-icons-left.has-icons-right
                        input.input.is-dark(
                          type='text', 
                          placeholder='0.00',
                          v-model="ivaP2",
                          min="0",
                          :disabled="isDisabled"
                        )
                .column.is-3
                  .field
                    label.label Moneda
                    input#checkM_MN2.is-checkradio.is-dark(type='radio', value='0' v-model='monedaP2' checked='checked' :disabled="isDisabled")
                    label.is-size-6(for='checkM_MN2') MN
                    input#checkM_Ext2.is-checkradio.is-dark(type='radio', value='1' v-model='monedaP2' :disabled="isDisabled")
                    label.is-size-6(for='checkM_Ext2') USD
                
                .column.is-1
                  .field
                    input#cbP2.is-checkradio.is-danger(type='checkbox' v-model='selProveedor2' :disabled="isDisabled")
                    label.is-size-6(for='cbP2')
              .columns.is-vcentered
                .column.is-6(v-show="!verSpanFile2")
                  .field
                    .file.is-black.has-name
                      label.file-label
                        input.file-input(type='file' ref="inputCotizacion2" @change="previewfileCotizacion($event, 2)" accept="application/pdf" :disabled="isDisabled")
                        span.file-cta
                          span.file-icon
                            i.fas.fa-upload
                          span.file-label
                            | Cotización&mldr;
                        span.file-name
                          | {{ fileCotizacion2.name }}&nbsp
                          button.delete.is-small(@click="deleteFile(2)")
                .column.is-6(v-show="verSpanFile2 && Object.keys(cotizacionEdit).length > 0")
                  span.tag.is-black
                    | {{ Object.keys(cotizacionEdit).length > 0 ? getFile(cotizacionEdit.cotizaciones[1].rutaFileCot) : ''}}
                  a.button.is-danger.is-rounded.is-small(@click="deleteCot(2)")
                    i.fas.fa-times
                .column.is-1
                  .field
                    label.label Usuario
                .column.is-4
                  TypeaheadUsuario(:options="usuarios" :optionSelect="usuarioSel2" v-model="usuarioSel2" :isDisabled="isDisabled")
    .columns
      .column.is-12
        bulma-accordion
          bulma-accordion-item
            p.title.is-4.has-text-weight-normal(slot='title')
              | Proveedor 3&nbsp
              span.tag(:class="selProveedor3 ? 'is-danger': ''" v-show='Object.keys(itemSelProv3).length > 0')
                | {{ itemSelProv3.nombre}} | {{totalP3 | currency}}
            i.material-icons(slot='icon') more_vert
            .high(slot='content') 
              .columns
                .column.is-4
                  .field
                    label.label Nombre Proveedor
                    TypeaheadProveedor(:options="proveedores" :optionSelect="itemSelProv3" v-model="itemSelProv3" :isDisabled="isDisabled")
                .column.is-2
                  .field
                    label.label Total
                      .control.has-icons-left.has-icons-right
                        input.input.is-dark(
                          type='text', 
                          placeholder='Total',
                          v-model="totalP3"
                          :disabled="isDisabled"
                        )
                .column.is-2
                  .field
                    label.label IVA
                      .control.has-icons-left.has-icons-right
                        input.input.is-dark(
                          type='text', 
                          placeholder='0.00',
                          v-model="ivaP3",
                          min="0",
                          :disabled="isDisabled"
                        )
                .column.is-3
                  .field
                    label.label Moneda
                    input#checkM_MN3.is-checkradio.is-dark(type='radio', value='0' v-model='monedaP3' checked='checked' :disabled="isDisabled")
                    label.is-size-6(for='checkM_MN3') MN
                    input#checkM_Ext3.is-checkradio.is-dark(type='radio', value='1' v-model='monedaP3' :disabled="isDisabled")
                    label.is-size-6(for='checkM_Ext3') USD
                
                .column.is-1
                  .field
                    input#cbP3.is-checkradio.is-danger(type='checkbox' v-model='selProveedor3' :disabled="isDisabled")
                    label.is-size-6(for='cbP3')
              .columns.is-vcentered
                .column.is-6(v-show="!verSpanFile3")
                  .field
                    .file.is-black.has-name
                      label.file-label
                        input.file-input(type='file' ref="inputCotizacion3" @change="previewfileCotizacion($event, 3)" accept="application/pdf" :disabled="isDisabled")
                        span.file-cta
                          span.file-icon
                            i.fas.fa-upload
                          span.file-label
                            | Cotización&mldr;
                        span.file-name
                          | {{ fileCotizacion3.name }}&nbsp
                          button.delete.is-small(@click="deleteFile(3)")
                .column.is-6(v-show="verSpanFile3 && Object.keys(cotizacionEdit).length > 0")
                  span.tag.is-black
                    | {{ Object.keys(cotizacionEdit).length > 0 ? getFile(cotizacionEdit.cotizaciones[2].rutaFileCot) : ''}}
                  a.button.is-danger.is-rounded.is-small(@click="deleteCot(3)")
                    i.fas.fa-times
                .column.is-1
                  .field
                    label.label Usuario
                .column.is-4
                  TypeaheadUsuario(:options="usuarios" :optionSelect="usuarioSel3" v-model="usuarioSel3" :isDisabled="isDisabled")
    .columns(v-show="datosFaltantes.length > 0")
      .column.is-12
        .notification
          .field.is-grouped.is-grouped-multiline
            .control(v-for="datosF in datosFaltantes")
              .tags
                span.tag.is-danger.is-light {{ datosF }}
    .columns
      .column.is-2
        a.button.is-black.is-rounded(@click="checkForm")
          | Guardar
</template>

<script>
  import Loader from '@/components/shared/Loader'
  import InventarioServices from '@/services/inventario/inventario';
  import TypeaheadProveedor from './TypeaheadProveedor.vue'
  import TypeaheadUsuario from '@/components/usuarios_Componentes/componentes/TypeaheadUsuario.vue'
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import moment from 'moment'
  import { mapState } from 'vuex'

  export default {
    name: 'FormCotizacion',
    components: { Loader, TypeaheadProveedor, TypeaheadUsuario, BulmaAccordion, BulmaAccordionItem, flatPickr },
    props: {
      usuarios: {
        type: Array,
        default: () => []
      },
    },
    data() {
      return {
        cotizacion: {},
        datosFaltantes: [],
        usuariosSel: {},
        proveedores: [],
        itemDataPort1: {},
        itemDataPort2: {},
        itemDataPort3: {},
        itemDataPortA: {},
        itemDataUser: {},
        itemSelProv1: {},
        itemSelProv2: {},
        itemSelProv3: {},
        itemSelProvSelect: {},
        itemSelUser: {},
        totalP1: 0,
        monedaP1: null,
        totalP2: 0,
        monedaP2: null,
        totalP3: 0,
        monedaP3: null,
        ivaP1: 0,
        ivaP2: 0,
        ivaP3: 0,
        datosFaltantes: [],
        fileCotizacion1: '',
        fileCotizacion2: '',
        fileCotizacion3: '',
        usuarioSel1: {},
        usuarioSel2: {},
        usuarioSel3: {},
        selProveedor1: true,
        selProveedor2: false,
        selProveedor3: false,
        selProvedorSelected: 1,
        itemSelProveedor: {},
        verSpanFile1: false,
        verSpanFile2: false,
        verSpanFile3: false,
        isDisabled: false,
        periodo: moment().format('YYYY-MM'),
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m',
          altInput: true,
          dateFormat: 'Y-m',
          locale: Spanish, // locale for this instance only          
        },
        ubicaciones: [
          { id: 'IRGE', valor: 'IRGE' },
          { id: 'TPA', valor: 'TPA' },
          { id: 'LPG_DUCTO', valor: 'DUCTO' },
          { id: 'CORP', valor: 'CORPORATIVO' }
        ],
        conceptos: [
          { nombre: 'Gastos Administravos', valor: '0'},
          { nombre: 'Gastos de Operación', valor: '1'},
          { nombre: 'Gastos de Seguridad', valor: '2'},
          { nombre: 'Gastos de Mantto. Preventivo', valor: '3'},
          { nombre: 'Gastos de Mantto. Correctivo', valor: '4'},
          { nombre: 'Gastos de Administración (OPS)', valor: '5'},
          { nombre: 'Gastos de Instrumentación y Sist.', valor: '6'},
          { nombre: 'Nuevos Proyectos', valor: '7'}
        ],
        ubicacion: null,
        concepto: null,
        tipo: '1',
        descripcion: null,
        dataCotizaciones: {},
        activarGuardar: true,
        activarEditar: false,
        activarUpdating: false,
      }
    },
    watch: {
      selProveedor1() {
        if (this.selProveedor1) {
          this.changeProveedorSel(1)
        }
      },
      selProveedor2() {
        if (this.selProveedor2) {
          this.changeProveedorSel(2)
        }
      },
      selProveedor3() {
        if (this.selProveedor3) {
          this.changeProveedorSel(3)
        }
      },
      totalP1 () {
        this.ivaP1 = (this.totalP1 * 16) / 100
      },
      totalP2 () {
        this.ivaP2 = (this.totalP2 * 16) / 100
      },
      totalP3 () {
        this.ivaP3 = (this.totalP3 * 16) / 100
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerProveedores()  
      },
      checkForm () {
        this.datosFaltantes = []
        if (this.descripcion && this.ubicacion && this.concepto && this.selProvedorSelected > 0 &&
          Object.keys(this.itemSelProv1).length > 0 && this.monedaP1 && this.totalP1 && 
          Object.keys(this.itemSelProv2).length > 0 && this.monedaP2 && this.totalP2 &&  
          Object.keys(this.itemSelProv3).length > 0 && this.monedaP3 && this.totalP3 &&
          this.fileCotizacion1 !== '' && this.fileCotizacion2 !== '' && this.fileCotizacion3 !== ''
          ) {
          this.enviarDataForm()
        } else {
          if (!this.descripcion) {
            this.datosFaltantes.push('La descripción es requerida.')
          }

          if (!this.ubicacion) {
            this.datosFaltantes.push('La ubicación es requerida.')
          }

          if (!this.concepto) {
            this.datosFaltantes.push('El concepto es requerido.')
          }

          if (this.selProvedorSelected == 0) {
            this.datosFaltantes.push('Es necesario que seleccione un proveedor.')
          }

          if (!this.totalP1 > 0) {
            this.datosFaltantes.push('El total del Proveedor 1 es requerido.')
          }
          if (!this.totalP2 > 0) {
            this.datosFaltantes.push('El total del Proveedor 2 es requerido.')
          }
          if (!this.totalP3 > 0) {
            this.datosFaltantes.push('El total del Proveedor 3 es requerido.')
          }
          
          if (!this.monedaP1) {
            this.datosFaltantes.push('El tipo de moneda del Proveedor 1 es requerido.')
          }
          if (!this.monedaP2) {
            this.datosFaltantes.push('El tipo de moneda del Proveedor 2 es requerido.')
          }
          if (!this.monedaP3) {
            this.datosFaltantes.push('El tipo de moneda del Proveedor 3 es requerido.')
          }
          
          if (Object.keys(this.itemSelProv1).length == 0) {
            this.datosFaltantes.push('El proveedor 1 es requerido')
          }

          if (Object.keys(this.itemSelProv2).length == 0) {
            this.datosFaltantes.push('El proveedor 2 es requerido')
          }

          if (Object.keys(this.itemSelProv3).length == 0) {
            this.datosFaltantes.push('El proveedor 3 es requerido')
          }
          
          if (this.fileCotizacion1 === '') {
            this.datosFaltantes.push('Debe agregar un archivo pdf para la cotización del proveedor 1.')
          }

          if (this.fileCotizacion2 === '') {
            this.datosFaltantes.push('Debe agregar un archivo pdf para la cotización del proveedor 2.')
          }

          if (this.fileCotizacion3 === '') {
            this.datosFaltantes.push('Debe agregar un archivo pdf para la cotización del proveedor 3.')
          }
        }
      },
      obtenerProveedores () {
        InventarioServices.getProveedores()
          .then( resp => {
            this.proveedores = resp
            if (Object.keys(this.cotizacionEdit).length > 0) {
              this.rellenarDataForm()
            }
          })
          .catch( e => console.log(e) )
      },
      previewfileCotizacion(event, cot) {
        console.log(cot)
        console.log(event)
        switch (cot) {
          case 1:
            this.fileCotizacion1 = event.target.files[0]
            break
          case 2:
            this.fileCotizacion2 = event.target.files[0]
            break
          case 3:
            this.fileCotizacion3 = event.target.files[0]
            break
        
          default:
            break
        }
      },
      enviarDataForm () {
        let provedorSel = {}
        let totalSel = 0
        let monedaSel = 0
        let ivaSel = 0
        let subtotalSel = 0

        switch (parseInt(this.selProvedorSelected)) {
          case 1:
            console.log(1)
            provedorSel = this.itemSelProv1
            totalSel = this.totalP1
            monedaSel = this.monedaP1
            ivaSel = this.ivaP1
            subtotalSel = Number(this.totalP1) - Number(this.ivaP1)
            break
          case 2:
            console.log(2)
            provedorSel = this.itemSelProv2
            totalSel = this.totalP2
            monedaSel = this.monedaP2
            ivaSel = this.ivaP2
            subtotalSel = Number(this.totalP2) - Number(this.ivaP2)
            break
          case 3:
            console.log(3)
            provedorSel = this.itemSelProv3
            totalSel = this.totalP3
            monedaSel = this.monedaP3
            ivaSel = this.ivaP3
            subtotalSel = Number(this.totalP3) - Number(this.ivaP3)
            break
          default:
            console.log(0)
            provedorSel = null
            totalSel = null
            monedaSel = null
            ivaSel = null
            subtotalSel = null
            break
        }

        let items = [
          {
            idUsuario: this.usuarioSel1.id,
            usuario: this.usuarioSel1.nombre,
            file: this.fileCotizacion1,
            fileName: this.fileCotizacion1.name,
            idCot: Object.keys(this.cotizacionEdit).length > 0 ? this.cotizacionEdit.cotizaciones[0].idCotizacion : null,
            status: this.fileCotizacion1 === '' ? false : true,
            proveedor: this.itemSelProv1,
            moneda: Number(this.monedaP1),
            total: Number(this.totalP1),
            iva: Number(this.ivaP1)
          },
          {
            idUsuario: this.usuarioSel2.id,
            usuario: this.usuarioSel2.nombre,
            file: this.fileCotizacion2,
            fileName: this.fileCotizacion2.name,
            idCot: Object.keys(this.cotizacionEdit).length > 0 ? this.cotizacionEdit.cotizaciones[1].idCotizacion : null,
            status: this.fileCotizacion2 === '' ? false : true,
            proveedor: this.itemSelProv2,
            moneda: Number(this.monedaP2),
            total: Number(this.totalP2),
            iva: Number(this.ivaP2)
          },
          {
            idUsuario: this.usuarioSel3.id,
            usuario: this.usuarioSel3.nombre,
            file: this.fileCotizacion3,
            fileName: this.fileCotizacion3.name,
            idCot: Object.keys(this.cotizacionEdit).length > 0 ? this.cotizacionEdit.cotizaciones[2].idCotizacion : null,
            status: this.fileCotizacion3 === '' ? false : true,
            proveedor: this.itemSelProv3,
            moneda: Number(this.monedaP3),
            total: Number(this.totalP3),
            iva: Number(this.ivaP3)
          }
        ]

        let myObjForm = {
          descripcion: this.descripcion,
          periodo: this.periodo,
          ubicacion: this.ubicacion,
          concepto: parseInt(this.concepto),
          tipo: parseInt(this.tipo),
          proveedorAsignado: this.selProvedorSelected,
          provedorSel: provedorSel,
          totalSel: Number(totalSel),
          monedaSel: parseInt(monedaSel),
          ivaSel: Number(ivaSel),
          subtotalSel: Number(subtotalSel),
          cotizaciones: items,
        }
        console.log(myObjForm)
        
        this.dataCotizaciones = Object.assign({}, this.dataCotizaciones, myObjForm)
        this.isDisabled = true
        this.activarGuardar = false
        this.activarEditar = true
        this.$emit('saveFormCotizacion', this.dataCotizaciones)
      },
      limpiarForm() {
        this.tipo = '1'
        this.ubicacion = null
        this.itemSelProv1 = {}
        this.itemSelProv2 = {}
        this.itemSelProv3 = {}
        this.itemSelProvSelect = {}
        this.itemSelUser = {}
        this.totalP1 = 0
        this.monedaP1 = null
        this.totalP2 = 0
        this.monedaP2 = null
        this.totalP3 = 0
        this.monedaP3 = null
        this.ivaP1 = 0
        this.ivaP2 = 0
        this.ivaP3 = 0
        this.fileCotizacion1 = ''
        this.fileCotizacion2 = ''
        this.fileCotizacion3 = ''
        this.usuarioSel1 = {}
        this.usuarioSel2 = {}
        this.usuarioSel3 = {}
      },
      changeProveedorSel (numProv) {
        console.log(numProv)
        switch (numProv) {
          case 1:
            this.selProvedorSelected = 1
            this.selProveedor2 = false
            this.selProveedor3 = false
            break
          case 2:
            this.selProvedorSelected = 2
            this.selProveedor1 = false
            this.selProveedor3 = false
            break
          case 3:
            this.selProvedorSelected = 3
            this.selProveedor1 = false
            this.selProveedor2 = false
            break
          default:
            this.selProvedorSelected = 0
            this.selProveedor1 = false
            this.selProveedor2 = false
            this.selProveedor3 = false
            break
        }
      },
      cancelProveedorSel (numProv) {
        console.log(numProv)
        switch (numProv) {
          case 1:
            this.itemSelProveedor = 0
            break
          case 2:
            this.itemSelProveedor = 0
            break
          case 1:
            this.itemSelProveedor = 0
            break
        
          default:
            break
        }
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['userLogin', 'cotizacionEdit'])
    }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/cotizaciones_Componentes/componentes/FormCotizacion.vue